<template>
    <!-- Container para toda la página: ******************************************************* -->
    <v-container fill-height fluid class="users">
        <!-- Layout para toda la página: *********************************************************** -->
        <v-layout align-center justify-center>
            <!-- Flex para la ventana: **************************************************************** -->
            <v-flex xs12 sm10 elevation-6>
                <div class="sub-window">
                    <v-toolbar dense dark color="teal darken-3">
                        <v-toolbar-title>Usuarios&nbsp;&nbsp;</v-toolbar-title>
                        <v-text-field
                            :disabled="bEdit"
                            hide-details
                            single-line
                            v-model="searchText"
                        ></v-text-field>
                        <v-btn :disabled="bEdit" small icon @click="onSearch">
                            <v-icon>mdi-magnify</v-icon>
                        </v-btn>
                        <v-spacer></v-spacer>
                        <v-toolbar-items class="hidden-sm-and-down">
                            <v-btn
                                :disabled="bEdit"
                                text
                                class="text-none"
                                @click="onNewUser"
                            >Nuevo Usuario</v-btn>
                            <v-btn
                                :disabled="(bEdit || userID === 0 )"
                                text
                                class="text-none"
                                @click="onEditUser"
                            >Editar Usuario</v-btn>
                            <v-btn
                                :disabled="(bEdit || userID === 0 )"
                                text
                                class="text-none"
                                @click="onDeleteUser"
                            >Borrar Usuario</v-btn>
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                    <v-btn text :disabled="bEdit" @click="onClose" v-on="on">
                                        <v-icon>mdi-close</v-icon>
                                    </v-btn>
                                </template>
                                <span>Cerrar</span>
                            </v-tooltip>
                        </v-toolbar-items>

                        <!-- Menú lateral para dispositivos con ventanas chicas: -->
                        <v-menu offset-y>
                            <template v-slot:activator="{ on }">
                                <v-btn icon v-on="on" class="hidden-md-and-up">
                                    <v-icon>mdi-dots-vertical</v-icon>
                                </v-btn>
                            </template>
                            <v-list color="grey lighten-4">
                                <v-list-item :disabled="bEdit" @click="onNewUser">
                                    <v-list-item-title>
                                        <v-icon color="teal darken-1">mdi-account-plus</v-icon>&nbsp; Nuevo Usuario
                                    </v-list-item-title>
                                </v-list-item>
                                <v-list-item :disabled="bEdit" @click="onEditUser">
                                    <v-list-item-title>
                                        <v-icon color="teal darken-1">mdi-account-edit</v-icon>&nbsp; Editar Usuario
                                    </v-list-item-title>
                                </v-list-item>
                                <v-list-item :disabled="bEdit" @click="onDeleteUser">
                                    <v-list-item-title>
                                        <v-icon color="teal darken-1">mdi-account-remove</v-icon>&nbsp; Borrar Usuario
                                    </v-list-item-title>
                                </v-list-item>
                                <v-divider></v-divider>
                                <v-list-item :disabled="bEdit" @click="onClose">
                                    <v-list-item-title>
                                        <v-icon color="red">mdi-close</v-icon>&nbsp; Cerrar
                                    </v-list-item-title>
                                </v-list-item>
                            </v-list>
                        </v-menu>
                    </v-toolbar>

                    <!-- Container para lista de usuarios y usuario seleccionado: -->
                    <v-container pa-2 grid-list-md>
                        <!-- Renglón único para lista de usuarios y card de usuario seleccionado: -->
                        <v-layout row wrap justify-space-around>
                            <!-- Lista de Usuarios: *************************** -->
                            <v-flex xs10 sm3>
                                <v-card>
                                    <v-toolbar dense color="teal darken-1" dark flat>
                                        <v-toolbar-title class="my-list-title">Usuarios Registrados</v-toolbar-title>
                                        <v-spacer></v-spacer>
                                        <v-icon>mdi-format-list-bulleted</v-icon>
                                    </v-toolbar>

                                    <v-list
                                        subheader
                                        dense
                                        :height="listHeight"
                                        max-height="100%"
                                        class="overflow-y-auto"
                                        :disabled="bEdit"
                                        color="grey lighten-4"
                                    >
                                        <v-list-item-group
                                            v-model="selectedUserIndex"
                                            color="orange accent-4"
                                            :mandatory="!bNew"
                                        >
                                            <v-list-item
                                                class="my-list-item"
                                                v-for="(user, i) in users"
                                                :key="i"
                                                @click="selectUser(user.usuarioid)"
                                            >
                                                <v-list-item-content>
                                                    <v-list-item-title>
                                                        <v-container pa-0 fluid>
                                                            <v-layout row wrap>
                                                                <v-flex
                                                                    md2
                                                                    xs6
                                                                >{{ user.appaterno + " " + user.apmaterno + " " + user.nombre }}</v-flex>
                                                            </v-layout>
                                                        </v-container>
                                                    </v-list-item-title>
                                                </v-list-item-content>
                                            </v-list-item>
                                        </v-list-item-group>
                                    </v-list>
                                </v-card>
                            </v-flex>

                            <!-- Termina Lista de Usuarios ********************************* -->

                            <!-- Info de usuario seleccionado: *********************** -->
                            <v-flex xs10 sm9>
                                <v-card class="grey lighten-4">
                                    <v-toolbar dense color="teal lighten-3" flat>
                                        <v-toolbar-title
                                            class="my-list-title"
                                        >{{ selectedUserName }}</v-toolbar-title>
                                        <v-spacer></v-spacer>
                                        <v-icon v-if="active === true">mdi-account</v-icon>
                                        <v-icon v-if="active === false">mdi-account-off</v-icon>
                                    </v-toolbar>

                                    <v-card-text>
                                        <v-container fluid>
                                            <v-layout wrap justify-space-between>
                                                <v-flex xs12>
                                                    <v-switch
                                                        dense
                                                        v-model="active"
                                                        label="Usuario activo"
                                                        color="orange accent-4"
                                                        :readonly="!bEdit"
                                                    ></v-switch>
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row wrap justify-space-between>
                                                <v-flex xs12 md8>
                                                    <v-text-field
                                                        dense
                                                        prepend-icon="mdi-email"
                                                        name="email"
                                                        label="Correo Electrónico"
                                                        type="email"
                                                        v-model="email"
                                                        :rules="emailRules"
                                                        :readonly="!bEdit || !bNew"
                                                        color="teal darken-3"
                                                        ref="email_field"
                                                    ></v-text-field>
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row wrap>
                                                <v-flex xs12 md3>
                                                    <v-text-field
                                                        dense
                                                        prepend-icon="mdi-account"
                                                        name="name"
                                                        label="Nombre(s)"
                                                        type="text"
                                                        v-model="name"
                                                        :readonly="!bEdit"
                                                        color="teal darken-3"
                                                    ></v-text-field>
                                                </v-flex>
                                                <v-flex xs11 offset-xs1 md3>
                                                    <v-text-field
                                                        dense
                                                        name="lastName1"
                                                        label="Apellido Paterno"
                                                        type="text"
                                                        v-model="lastName1"
                                                        :readonly="!bEdit"
                                                        color="teal darken-3"
                                                    ></v-text-field>
                                                </v-flex>
                                                <v-flex xs11 offset-xs1 md3>
                                                    <v-text-field
                                                        dense
                                                        name="lastName2"
                                                        label="Apellido Materno"
                                                        type="text"
                                                        v-model="lastName2"
                                                        :readonly="!bEdit"
                                                        color="teal darken-3"
                                                    ></v-text-field>
                                                </v-flex>
                                            </v-layout>


                                            <v-layout row wrap justify-space-between>
                                                <v-flex xs12 md8>
                                                    <v-select
                                                        dense
                                                        prepend-icon="mdi-account-star"
                                                        :items="userTypes"
                                                        item-text="descripcion"
                                                        item-value="tipoid"
                                                        v-model="userTypeID"
                                                        label="Tipo de Usuario"
                                                        :readonly="!bEdit"
                                                        color="teal darken-3"
                                                        item-color="teal darken-3"
                                                        no-data-text="No hay tipos de usuario registrados"
                                                        @change="onSelectUserType"
                                                    ></v-select>
                                                </v-flex>
                                            </v-layout>

                                            <v-layout v-if="bNew" row wrap>
                                                <v-flex xs10 md4>
                                                    <v-text-field
                                                        prepend-icon="mdi-lock"
                                                        name="password"
                                                        label="Contraseña"
                                                        id="password1"
                                                        type="password"
                                                        required
                                                        v-model="password1"
                                                        @click:append="() => (e1 = !e1)"
                                                        :type="e1 ? 'password' : 'text'"
                                                        :rules="passwordRules"
                                                        :readonly="!bEdit"
                                                        color="teal darken-3"
                                                    ></v-text-field>
                                                </v-flex>

                                                <v-flex xs10 md4 offset-md1>
                                                    <v-text-field
                                                        name="password"
                                                        label="Verificar contraseña"
                                                        id="password2"
                                                        type="password"
                                                        required
                                                        v-model="password2"
                                                        :append-icon="e1 ? 'mdi-eye-off' : 'mdi-eye'"
                                                        @click:append="() => (e1 = !e1)"
                                                        :type="e1 ? 'password' : 'text'"
                                                        :rules="passwordRules"
                                                        :readonly="!bEdit"
                                                        color="teal darken-3"
                                                    ></v-text-field>
                                                </v-flex>
                                            </v-layout>

                                            <v-layout
                                                v-if="bEdit && !bNew"
                                                row
                                                wrap
                                                justify-space-between
                                            >
                                                <v-flex xs8 md5>
                                                    <!-- Modal para cambio de Password: **************************************** -->
                                                    <v-dialog
                                                        v-model="dlgChangePasswd"
                                                        persistent
                                                        max-width="40%"
                                                    >
                                                        <template v-slot:activator="{ on }">
                                                            <v-btn
                                                                class="teal lighten-3 text-none"
                                                                small
                                                                v-on="on"
                                                            >Cambiar Contraseña</v-btn>
                                                        </template>
                                                        <v-card class="grey lighten-4">
                                                            <v-toolbar
                                                                dense
                                                                color="teal lighten-3"
                                                                flat
                                                            >
                                                                <v-toolbar-title
                                                                    class="my-list-title"
                                                                >Cambio de Contraseña - {{ selectedUserName }}</v-toolbar-title>
                                                                <v-spacer></v-spacer>
                                                                <v-icon>mdi-key</v-icon>
                                                            </v-toolbar>
                                                            <v-card-text>
                                                                <v-container grid-list-md>
                                                                    <v-layout
                                                                        row
                                                                        wrap
                                                                        justify-space-around
                                                                    >
                                                                        <v-flex xs12 md8>
                                                                            <v-text-field
                                                                                prepend-icon="mdi-lock"
                                                                                name="password"
                                                                                label="Contraseña nueva"
                                                                                id="new_password1"
                                                                                type="password"
                                                                                required
                                                                                v-model="newPassword1"
                                                                                :append-icon="e1 ? 'mdi-eye-off' : 'mdi-eye'"
                                                                                @click:append="() => (e1 = !e1)"
                                                                                :type="e1 ? 'password' : 'text'"
                                                                                :rules="passwordRules"
                                                                                color="teal darken-3"
                                                                            ></v-text-field>
                                                                        </v-flex>
                                                                    </v-layout>
                                                                    <v-layout
                                                                        row
                                                                        wrap
                                                                        justify-space-around
                                                                    >
                                                                        <v-flex xs12 md8>
                                                                            <v-text-field
                                                                                prepend-icon="mdi-lock"
                                                                                name="password"
                                                                                label="Verificar contraseña"
                                                                                id="new_password2"
                                                                                type="password"
                                                                                required
                                                                                v-model="newPassword2"
                                                                                @click:append="() => (e1 = !e1)"
                                                                                :type="e1 ? 'password' : 'text'"
                                                                                :rules="passwordRules"
                                                                                color="teal darken-3"
                                                                            ></v-text-field>
                                                                        </v-flex>
                                                                    </v-layout>
                                                                </v-container>
                                                            </v-card-text>
                                                            <v-card-actions>
                                                                <v-spacer></v-spacer>
                                                                <v-btn
                                                                    color="teal darken-3"
                                                                    class="text-none"
                                                                    text
                                                                    @click="changePassword"
                                                                >OK</v-btn>
                                                                <v-btn
                                                                    color="pink darken-1"
                                                                    class="text-none"
                                                                    text
                                                                    @click="cancelChangePassword"
                                                                >Cancelar</v-btn>
                                                            </v-card-actions>
                                                        </v-card>
                                                    </v-dialog>
                                                    <!-- Termina Modal para cambio de Password *************************** -->
                                                </v-flex>
                                            </v-layout>

                                            <v-layout
                                                v-if="bEdit"
                                                align-center
                                                justify-end
                                                row
                                                fill-height
                                            >
                                                <v-flex xs12 sm8 class="text-xs-center text-end">
                                                    <v-btn
                                                        color="teal darken-3"
                                                        class="text-none"
                                                        text
                                                        @click="onSave"
                                                        :disabled="!bEdit"
                                                    >OK</v-btn>
                                                    <v-btn
                                                        color="pink darken-1"
                                                        class="text-none"
                                                        text
                                                        @click="onCancel"
                                                        :disabled="!bEdit"
                                                    >Cancelar</v-btn>
                                                </v-flex>
                                            </v-layout>
                                        </v-container>
                                    </v-card-text>
                                </v-card>
                            </v-flex>
                            <!-- Termina info de usuario seleccionado *********************** -->
                        </v-layout>

                        <!-- Modal para confirmar borrado de usuario: **************************************** -->
                        <v-layout row justify-center>
                            <v-dialog v-model="bDeletingUser" persistent width="35%">
                                <v-card class="grey lighten-4">
                                    <v-toolbar dense color="orange darken-2" dark flat>
                                        <v-toolbar-title class="my-list-title">Borrar Usuario</v-toolbar-title>
                                        <v-spacer></v-spacer>
                                        <v-icon>mdi-delete</v-icon>
                                    </v-toolbar>
                                    <v-card-title class="text-center">
                                        <div style="margin: auto">
                                            <v-icon large color="orange darken-2">mdi-alert</v-icon>
                                        </div>
                                        &nbsp; ¿Desea borrar al usuario {{ selectedUserName }}?
                                    </v-card-title>
                                    <v-card-text
                                        class="text-center"
                                    >Esta acción no se puede deshacer.</v-card-text>
                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn
                                            color="teal darken-3"
                                            class="text-none"
                                            text
                                            @click="deleteUserConfirmed"
                                        >OK</v-btn>
                                        <v-btn
                                            color="pink darken-1"
                                            class="text-none"
                                            text
                                            @click="cancelDeleteUser"
                                        >Cancelar</v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </v-layout>
                        <!-- Termina Modal para confirmar borrado de usuario *************************** -->

                        <!-- Modal para informar que no hubo resultados en la búsqueda: *********************************** -->
                        <v-layout row justify-center>
                            <v-dialog v-model="bShowNotFoundAlert" persistent max-width="30%">
                                <v-card class="grey lighten-4">
                                    <v-toolbar dense color="teal" dark flat>
                                        <v-toolbar-title class="my-list-title">Búsqueda de Usuarios</v-toolbar-title>
                                        <v-spacer></v-spacer>
                                        <v-icon>search</v-icon>
                                    </v-toolbar>
                                    <v-card-text>
                                        <v-container>
                                            <v-layout row>
                                                <v-flex xs12 class="d-flex justify-center">
                                                    <v-icon large color="orange darken-2">warning</v-icon>
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row>
                                                <v-flex
                                                    xs12
                                                    class="d-flex justify-center"
                                                >No hay usuarios registrados con ese nombre.</v-flex>
                                            </v-layout>
                                        </v-container>
                                    </v-card-text>

                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn
                                            color="teal darken-3"
                                            class="text-none"
                                            text
                                            @click="bShowNotFoundAlert = false"
                                        >OK</v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </v-layout>
                        <!-- Termina Modal para informar que no hubo resultados en la búsqueda *************************** -->

                        <!-- Modal para informar que los passwords no coinciden: *********************************** -->
                        <v-layout row justify-center>
                            <v-dialog v-model="bPasswdNotEqual" persistent :width="errorModalWidth">
                                <v-card class="grey lighten-4">
                                    <v-toolbar dense color="teal" dark flat>
                                        <v-toolbar-title
                                            class="my-list-title"
                                        >Error al establecer la contraseña</v-toolbar-title>
                                        <v-spacer></v-spacer>
                                        <v-icon>mdi-key</v-icon>
                                    </v-toolbar>
                                    <v-card-title>
                                        <v-container>
                                            <v-layout row>
                                                <v-flex xs12 class="d-flex justify-center">
                                                    <v-icon
                                                        large
                                                        color="orange darken-2"
                                                    >mdi-alert-circle</v-icon>
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row>
                                                <v-flex
                                                    xs12
                                                    class="d-flex justify-center"
                                                >Las contraseñas no coinciden.</v-flex>
                                            </v-layout>
                                        </v-container>
                                    </v-card-title>

                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn
                                            color="teal darken-3"
                                            class="text-none"
                                            text
                                            @click="bPasswdNotEqual = false"
                                        >OK</v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </v-layout>
                        <!-- Termina Modal para informar que los passwords no coinciden *************************** -->

                        <!-- Modal para pedir que se introduzcan todos los campos obligatorios: *********************************** -->
                        <v-layout row justify-center>
                            <v-dialog v-model="bInvalidData" persistent :width="errorModalWidth">
                                <v-card class="grey lighten-4">
                                    <v-toolbar dense color="teal" dark flat>
                                        <v-toolbar-title
                                            class="my-list-title"
                                        >Información Incompleta</v-toolbar-title>
                                        <v-spacer></v-spacer>
                                        <v-icon>mdi-alert-circle-outline</v-icon>
                                    </v-toolbar>
                                    <v-card-title>
                                        <v-container>
                                            <v-layout row>
                                                <v-flex xs12 class="d-flex justify-center">
                                                    <v-icon
                                                        large
                                                        color="orange darken-2"
                                                    >mdi-alert-circle</v-icon>
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row>
                                                <v-flex
                                                    xs12
                                                    class="d-flex justify-center"
                                                >{{ errorMessage }}</v-flex>
                                            </v-layout>
                                        </v-container>
                                    </v-card-title>

                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn
                                            color="teal darken-3"
                                            class="text-none"
                                            text
                                            @click="bInvalidData = false"
                                        >OK</v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </v-layout>
                        <!-- Termina modal para pedir que se introuzcan todos los campos *********************************** -->

                        <!-- Modal para indicar que ya existe otro usuario registrado con el mismo correo: *********************************** -->
                        <v-layout row justify-center>
                            <v-dialog
                                v-model="duplicatedUserError"
                                persistent
                                :width="errorModalWidth"
                            >
                                <v-card class="grey lighten-4">
                                    <v-toolbar dense color="teal" dark flat>
                                        <v-toolbar-title class="my-list-title">Usuario Duplicado</v-toolbar-title>
                                        <v-spacer></v-spacer>
                                        <v-icon>mdi-alert-circle-outline</v-icon>
                                    </v-toolbar>
                                    <v-card-title>
                                        <v-container>
                                            <v-layout row>
                                                <v-flex xs12 class="d-flex justify-center">
                                                    <v-icon
                                                        large
                                                        color="orange darken-2"
                                                    >mdi-alert-circle</v-icon>
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row>
                                                <v-flex
                                                    xs12
                                                    class="d-flex justify-center"
                                                >Ya existe otro usuario registrado con el mismo correo electrónico.</v-flex>
                                            </v-layout>
                                        </v-container>
                                    </v-card-title>

                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn
                                            color="teal darken-3"
                                            class="text-none"
                                            text
                                            @click="onDuplicatedUser"
                                        >OK</v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </v-layout>
                        <!-- Termina Modal para indicar que ya existe otro usuario registrado con el mismo correo *********************************** -->

                        <!-- Termina renglón único para lista de usuarios y usuario seleccionado -->
                    </v-container>
                    <!-- Termina container para lista de usuarios y usuario seleccionado -->
                </div>
            </v-flex>
            <!-- Fin Flex para la ventana **************************************************************** -->
        </v-layout>
        <!-- Fin Layout para toda la página *********************************************************** -->
        <v-overlay :value="waitCursor">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
    </v-container>
    <!-- Fin container para toda la página ********************************************* -->
</template>
<script>
import { mapGetters } from 'vuex';

export default {
    name: 'users',
    data() {
        return {
            drawer: false,
            bEdit: false,
            bNew: false,
            dlgChangePasswd: false,
            bChangePasswd: false,
            bPasswdNotEqual: false,
            bInvalidData: false,
            errorMessage: '',

            e1: true,
            userID: 0,
            active: false,
            name: '',
            lastName1: '',
            lastName2: '',
            email: '',

            userTypeID: 0, //1 = Superadmin, 2 = Admin
            password1: '',
            password2: '',
            newPassword1: '',
            newPassword2: '',
            emailRules: [
                (v) => !!v || 'Introduzca su correo electrónico',
                (v) =>
                    /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
                    'Introduzca un correo válido.',
            ],
            passwordRules: [
                (v) => !!v || 'Introduzca la contraseña',
                (v) =>
                    v.length >= 6 ||
                    'La contraseña debe tener al menos 6 caracteres.',
            ],
            selectedUserName: '',
            bDeletingUser: false,
            searchText: '',
            bShowNotFoundAlert: false, //Indica si se debe mostrar el diálogo que indica que no hubo resultados en la búsqueda.

            logoInfo: null, //Objeto regresado por el servidor con la información para reconstruir el archivo del logo.
            bLogo: false,
        };
    },
    created() {
        this.selectFirstUser();
        //console.log('Users: ', this.users);
    },
    
    methods: {
        onClose() {
            this.$router.push('/');
        },

        onSelectUserType() {
            
        },

        onNewUser() {
            this.bEdit = true;
            this.bNew = true;
            this.selectedUserName = 'Nuevo Usuario';
            this.selectedUserIndex = -1;

            this.userID = 0;
            this.active = true;
            this.name = '';
            this.lastName1 = '';
            this.lastName2 = '';
            this.email = '';
            this.userTypeID = 2; //Por default administrador de encuestas prepagadas, ya que es el más común.
            this.password1 = '';
            this.password2 = '';
            this.newPassword1 = '';
            this.newPassword2 = '';
            this.e1 = true;

            this.$refs.email_field.focus();
        },
        onDeleteUser() {
            this.bDeletingUser = true;
        },
        cancelDeleteUser() {
            this.bDeletingUser = false;
        },
        deleteUserConfirmed() {
            this.bDeletingUser = false;

            //Como el borrado en el servidor es asíncrono, antes de borrar el registro en el servidor se borra
            //el registro localmente. Si no, si el registro borrado era el primer registro, si primero se
            //borra en el servidor y después se selecciona el primer registro, es posible que se vuelva a
            //seleccionar el registro borrado antes de que éste se borre en el servidor.

            var i;
            for (i = 0; i < this.users.length; i++)
            {
                if (this.users[i].usuarioid === this.userID)
                {
                    this.users.splice(i, 1);
                    break;
                }
            }

            this.$store.dispatch('deleteUser', this.userID);
            this.selectFirstUser();
        },
        onEditUser() {
            this.newPassword1 = '';
            this.newPassword2 = '';
            this.e1 = true;
            this.bEdit = true;
        },
        changePassword() {
            if (this.newPassword1 === this.newPassword2) {
                this.dlgChangePasswd = false;
                this.bChangePasswd = true;
            } else {
                this.bPasswdNotEqual = true;
            }
        },
        cancelChangePassword() {
            this.dlgChangePasswd = false;
            this.bChangePasswd = false;
            this.newPassword1 = '';
            this.newPassword2 = '';
            this.e1 = true;
        },
        
        onCancel() {
            if (this.bNew) {
                //Selecciona al primer usuario de la lista:
                this.selectFirstUser();
                this.bNew = false;
            } else {
                this.newPassword1 = '';
                this.newPassword2 = '';
                this.e1 = true;
                //Vuelve a obtener los datos originales del usuario seleccionado:
                this.selectUser(this.userID);
            }
            this.bEdit = false;
        },
        onSave()
        {
            var bDataOK = false;
            var iActivo;
            if (this.active === true)
            {
                iActivo = 1;
            }
            else
            {
                iActivo = 0;
            }

            //Se validan los datos:

            if (this.email === '')
            {
                this.bInvalidData = true;
                this.errorMessage = 'El correo electrónico es obligatorio.';
            }
            else if (this.name === '')
            {
                this.bInvalidData = true;
                this.errorMessage = 'El nombre es obligatorio.';
            }
            else if (this.lastName1 === '')
            {
                this.bInvalidData = true;
                this.errorMessage = 'El apellido paterno es obligatorio.';
            }
            else if (this.userTypeID === 0)
            {
                this.bInvalidData = true;
                this.errorMessage = 'Selecione un tipo de usuario.';
            }
            else
            {
                bDataOK = true;
            }
            if (!this.bNew && bDataOK)
            {
                //Edición de usuario...
                var i;

                var password = '';
                if (this.bChangePasswd)
                {
                    password = this.newPassword1;
                    this.bChangePasswd = false;
                }

                const userInfo = {
                    usuarioid: this.userID,
                    activo: iActivo,
                    email: this.email,
                    nombre: this.name,
                    appaterno: this.lastName1,
                    apmaterno: this.lastName2,
                    tipoid: this.userTypeID,
                    password: password,
                };
                console.log('userInfo = ', userInfo);

                //Edición del registro en la BD:
                this.$store.dispatch('editUser', userInfo);

                //Se actualiza el registro local:
                for (i = 0; i < this.users.length; i++)
                {
                    if (this.users[i].usuarioid === this.userID)
                    {
                        this.users[i].activo = iActivo;
                        this.users[i].email = this.email;
                        this.users[i].nombre = this.name;
                        this.users[i].appaterno = this.lastName1;
                        this.users[i].apmaterno = this.lastName2;
                        this.users[i].tipoid = this.userTypeID;

                        break;
                    }
                }
            } //end edición de usuario.
            else if (this.bNew && bDataOK)
            {
                //Registro de nuevo usuario...
                //Se valida el password:
                bDataOK = false;
                if (this.password1 === '')
                {
                    this.bInvalidData = true;
                    this.errorMessage = 'Teclee la contraseña.';
                }
                else if (this.password2 === '')
                {
                    this.bInvalidData = true;
                    this.errorMessage = 'Verifique la contraseña.';
                }
                else if (this.password1 != this.password2)
                {
                    this.bInvalidData = true;
                    this.errorMessage = 'Las contraseñas no coinciden.';
                }
                else
                {
                    bDataOK = true;
                }

                if (bDataOK)
                {
                    this.bNew = false;

                    const newUser = {
                        admininterno: 1, //1 para todos los administradores
                        activo: iActivo,
                        email: this.email,
                        nombre: this.name,
                        appaterno: this.lastName1,
                        apmaterno: this.lastName2,
                        tipoid: this.userTypeID,
                        password: this.password1,
                    };

                    this.$store.dispatch('saveNewUser', newUser);
                }
            } //end registro de nuevo usuario.

            if (bDataOK)
            {
                this.selectedUserName = this.lastName1 + ' ' + this.lastName2 + ' ' + this.name;
                this.bEdit = false;
            }
        },
        selectFirstUser()
        {
            if (this.users.length > 0)
            {
                this.selectedUserIndex = 0;
                var userID = this.users[this.selectedUserIndex].usuarioid;
                this.selectUser(userID);
            }
            else
            {
                this.selectedUserIndex = -1;
                this.userID = 0;
            }
        },
        selectUser(userID)
        {
            var i;
            for (i = 0; i < this.users.length; i++)
            {
                if (this.users[i].usuarioid === userID)
                {
                    this.userID = userID;
                    if (this.users[i].activo === 1)
                    {
                        this.active = true;
                    }
                    else
                    {
                        this.active = false;
                    }

                    this.email = this.users[i].email;
                    this.name = this.users[i].nombre;
                    this.lastName1 = this.users[i].appaterno;
                    this.lastName2 = this.users[i].apmaterno;
                    this.userTypeID = this.users[i].tipoid;
                    this.selectedUserName = this.lastName1 + ' ' + this.lastName2 + ' ' + this.name;

                    break;
                }
            }
        },
        onSearch()
        {
            if (this.searchText != '')
            {
                //Se convierte el texto a minúsculas para hacer la comparación:

                var searchTextLowerCase = this.searchText.toLowerCase();

                var i;
                var bFound = false;
                for (i = 0; i < this.users.length; i++)
                {
                    var strLowerCaseText = this.users[i].appaterno.toLowerCase();
                    if (strLowerCaseText.indexOf(searchTextLowerCase) === 0)
                    {
                        this.selectedUserIndex = i;
                        this.selectUser(this.users[i].usuarioid);
                        bFound = true;
                        break;
                    }
                }
                if (!bFound)
                {
                    this.bShowNotFoundAlert = true;
                }
                this.searchText = '';
            }
        },

        onDuplicatedUser()
        {
            this.duplicatedUserError = false;
            this.selectedUserName = 'Nuevo Usuario';
            this.bEdit = true;
            this.bNew = true;
        },
    },
    computed:
    {
        ...mapGetters([
            'users',
            'waitCursor',
            'userTypes'
        ]),
        selectedUserIndex:
        {
            get() {
                return this.$store.getters.selectedUserIndex;
            },
            set(selectedUserIndex) {
                this.$store.dispatch(
                    'updateSelectedUserIndex',
                    selectedUserIndex
                );
            },
        },
        
        duplicatedUserError:
        {
            get() {
                return this.$store.getters.duplicatedUserError;
            },
            set(duplicatedUserError) {
                this.$store.dispatch(
                    'setDuplicatedUserError',
                    duplicatedUserError
                );
            },
        },

        // style="height: 578px; max-height:100%"
        listHeight() {
            var height;
            if (this.$vuetify.breakpoint.xs) {
                height = '200px';
            } else if (this.$vuetify.breakpoint.sm) {
                height = '700px';
            } else {
                height = '470px';
            }
            return height;
        },

        errorModalWidth() {
            var width = '100%';
            if (this.$vuetify.breakpoint.xs) {
                width = '80%';
            } else if (this.$vuetify.breakpoint.sm) {
                width = '60%';
            } else if (this.$vuetify.breakpoint.md) {
                width = '40%';
            } else if (this.$vuetify.breakpoint.lg) {
                width = '30%';
            } else if (this.$vuetify.breakpoint.xl) {
                width = '20%';
            }
            return width;
        },

        logoHeight() {
            var height;
            if (this.$vuetify.breakpoint.xs) {
                height = '40';
            } else if (this.$vuetify.breakpoint.sm) {
                height = '40';
            } else if (this.$vuetify.breakpoint.md) {
                height = '50';
            } else if (this.$vuetify.breakpoint.lg) {
                height = '60';
            } else {
                height = '80';
            }
            return height;
        },
    },
};
</script>

<style scoped>
.sub-window {
    /* background-color: #e0e0e0; */
    /*grey lighten-2 */
    background: rgba(224, 224, 224, 0.6);
}
.users {
    /* background: url('../assets/alex-kotliarskyi-QBpZGqEMsKg-unsplash.jpg'); */
    /*background: url('../assets/ben-rosett-WdJkXFQ4VHY-unsplash.jpg');*/
    background: url('../assets/hunters-race-MYbhN8KaaEc-unsplash.jpg');
    background-size: cover;
    width: 100%;
    height: 100%;
}

.my-list-title {
    font-size: 15px;
    font-weight: bold;
}
.my-list-subtitle {
    font-size: 13px;
    font-weight: bold;
}
.my-list-header {
    font-size: 11px;
    font-weight: bold;
    background-color: #e0e0e0;
}
.my-list-item {
    min-height: 30px !important;
}

/* ***************Modificaciones para que no se parta el texto en v-card-text y en v-card-title (al parecer es un bug de vuetify):************* */
.v-card__text,
.v-card__title {
    word-break: normal; /* maybe !important  */
}
</style>